var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 -8.30516e-07C29.4934 -1.2892e-06 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 -3.71835e-07 29.4934 -8.30516e-07 19C-1.2892e-06 8.50659 8.50659 -3.71835e-07 19 -8.30516e-07ZM19 35.15C27.9194 35.15 35.15 27.9194 35.15 19C35.15 10.0806 27.9194 2.85 19 2.85C10.0806 2.85 2.85 10.0806 2.85 19C2.85 27.9194 10.0806 35.15 19 35.15Z",
    fill: "#E0DDF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/InProgress.48890b79ddbe9d1bfbd516bf76179641.svg";
export { ForwardRef as ReactComponent };